import { Component } from '@angular/core';

interface MenuItem {
  name: string;
  price: number;
  description: string;
  type: string;
}

@Component({
  selector: 'app-carte',
  templateUrl: './carte.component.html',
  styleUrl: './carte.component.scss',
})
export class CarteComponent {
  private menuCache = new Map<string, MenuItem[]>();

  public get menuTypes(): string[] {
    return [...new Set(this.menuItems.map((item) => item.type))];
  }

  public filteredMenu(type: string): MenuItem[] {
    if (!this.menuCache.has(type)) {
      this.menuCache.set(
        type,
        this.menuItems.filter((item) => item.type === type),
      );
    }
    return this.menuCache.get(type)!;
  }

  public menuItems: MenuItem[] = [
    {
      name: 'Frites',
      price: 5,
      description: 'Frites maison croustillantes',
      type: 'Entrée',
    },
    {
      name: 'Confit',
      price: 20,
      description: 'Cuisse de canard confit, accompagné de frites maison',
      type: 'Plat',
    },
    {
      name: 'Magret',
      price: 28,
      description: 'Magret de canard, servi avec des frites maison',
      type: 'Plat',
    },
    {
      name: '1/2 Magret',
      price: 20,
      description: 'Demi-magret de canard, servi avec des frites maison',
      type: 'Plat',
    },
    {
      name: 'Saucisse',
      price: 12,
      description:
        'Saucisse de Toulouse grillée servie avec frite maison et salade',
      type: 'Plat',
    },
    {
      name: "Saucisse Piment d'espelette 500g",
      price: 32,
      description:
        "Saucisse porc noir au piment d'espelette à partager — selon arrivage",
      type: 'Plat',
    },
    {
      name: 'Salade de fromages',
      price: 16.5,
      description: 'Salade fraîche avec fromage (Chèvre, Roquefort)',
      type: 'Plat',
    },
    {
      name: 'Salade Gésiers',
      price: 18.5,
      description: 'Salade fraîche avec gésiers de canard confits',
      type: 'Plat',
    },
    {
      name: 'Soupe',
      price: 6,
      description: "Soupe à l'oignon et au fromage",
      type: 'Entrée',
    },
    {
      name: 'Menu enfant',
      price: 8.5,
      description: 'Saucisse de Toulouse, frite maison, salade, glace',
      type: 'Enfant',
    },
    {
      name: 'Menu enfant',
      price: 9.5,
      description: 'Saucisse de Toulouse, frite maison, salade, sirop, glace',
      type: 'Enfant',
    },
    {
      name: "Paté piment d'espelette ou rillette",
      price: 9,
      description:
        "Paté de porc noir au piment d'espelette ou Rillette à partager",
      type: 'Entrée',
    },
    {
      name: 'Planche Charcuterie/Fromage',
      price: 14,
      description: 'Planche de charcuterie et fromage à partager',
      type: 'Entrée',
    },
    {
      name: 'Mini Salade',
      price: 6.5,
      description: 'Mini salade fraîche',
      type: 'Entrée',
    },
    {
      name: 'Maxi saucisse',
      price: 22,
      description: 'Salade composé, frite et saucisse en grosse portion',
      type: 'Plat',
    },
    {
      name: 'Maxi Confit',
      price: 30,
      description: 'Salade composé, frite et confit en grosse portion',
      type: 'Plat',
    },
    {
      name: 'Maxi Carne',
      price: 40,
      description:
        'Salade composé, frite, saucisse puis magret ou confit au choix',
      type: 'Plat',
    },
    {
      name: 'Dessert',
      price: 7,
      description: 'Dessert du moment',
      type: 'Dessert',
    },
  ];
}
